// import PropTypes from 'prop-types';
import styles from './DownloadProductChooserModal.module.scss';
import Icon from '../Icon';
import { useEffect, useState } from 'react';
import { httpGet } from '../../utils/Http';
import { keysToCamelFromSnake } from '../../utils/caseconverters';
import Loader from '../Loader';
import classNames from 'classnames';

const NEXT_PUBLIC_API_DOMAIN = process.env.NEXT_PUBLIC_API_DOMAIN;

const DownloadRow = ({ title, downloadUrl, count, onClick, secondary }) => {
    const classes = classNames(
        styles['DownloadProductChooserModal__ListItem'],
        {
            [styles['DownloadProductChooserModal__ListItem--Secondary']]:
                secondary,
        }
    );

    const handleClick = (e) => {
        e.preventDefault();
        onClick(downloadUrl, { title, downloadUrl }); // Pass product data here
    };

    return (
        <li className={classes}>
            <a
                href={downloadUrl}
                onClick={handleClick}
                className={styles['DownloadProductChooserModal__Link']}>
                <span>{title}</span>
                <span className={styles['DownloadProductChooserModal__Sounds']}>
                    {count && count + ' sound' + (count > 1 ? 's' : '')}
                    <span
                        className={styles['DownloadProductChooserModal__Icon']}>
                        <Icon type="download" size="large" />
                    </span>
                </span>
            </a>
        </li>
    );
};

const DownloadProductChooserModal = ({
    title,
    products = [],
    legacyProducts = [],
    compatibleProducts = null,
    downloadUrl = null,
    onDownload,
    isFileOnlyDownload = false,
}) => {
    const [_products, setProducts] = useState(products);
    const [_legacyProducts, setLegacyProducts] = useState(legacyProducts);
    const [loading, setLoading] = useState(!!downloadUrl);
    const [isExpanded, setIsExpanded] = useState(false);

    const handleDownload = (href, product) => {
        setLoading(true);
        window.location = href;

        if (onDownload) {
            onDownload(product);  // Pass the selected product here
        }

        const isSingeDl = !href.match(/library|collection/);
        setTimeout(() => {
            const el = document.getElementById('modal-close-button');
            if (el) {
                el.click();
            }
        }, 1000 * (isSingeDl ? 4 : 8));
    };
    useEffect(() => {
        // Hack to make the modal work as a loader only
        if (downloadUrl) {
            handleDownload(downloadUrl);
        }
    }, []);

    useEffect(() => {
        if (compatibleProducts) {
            httpGet(NEXT_PUBLIC_API_DOMAIN + compatibleProducts).then(
                (data) => {
                    const _response = keysToCamelFromSnake(data);
                    setProducts(
                        _response.activeProducts.map((x) => ({
                            title: x.label,
                            ...x,
                        }))
                    );

                    setLegacyProducts(
                        _response.legacyProducts.map((x) => ({
                            title: x.label,
                            ...x,
                        }))
                    );
                }
            );
        }
    }, []);

    const classes = classNames(styles['DownloadProductChooserModal'], {
        [styles['DownloadProductChooserModal--Expanded']]: isExpanded,
    });

    return (
        <div className={classes}>
            <h5 className={styles['DownloadProductChooserModal__Title']}>
                Download <b>{title}</b>
            </h5>
            {loading && (
                <div className={styles['DownloadProductChooserModal__Loading']}>
                    <div
                        className={
                            styles['DownloadProductChooserModal__LoadingLoader']
                        }>
                        <Loader />
                    </div>

                    <p
                        className={
                            styles['DownloadProductChooserModal__LoadingText']
                        }>
                        {isFileOnlyDownload
                            ? 'Your download will start in a moment'
                            : 'Please wait while your samples are being prepared. Your download will start in a moment'}
                    </p>
                </div>
            )}

            {!loading && (
                <p
                    className={
                        styles['DownloadProductChooserModal__Description']
                    }>
                    <span
                        className={
                            styles[
                                'DownloadProductChooserModal__Description--Bold'
                            ]
                        }>
                        Select your product{' '}
                    </span>
                    to download.
                </p>
            )}

            {!loading && (
                <div
                    className={
                        styles['DownloadProductChooserModal__ListWrapper']
                    }>
                    <ul className={styles['DownloadProductChooserModal__List']}>
                        {_products.map((dl, i) => (
                            <DownloadRow
                                key={i}
                                {...dl}
                                onClick={handleDownload}
                            />
                        ))}
                        {!!_legacyProducts.length && (
                            <li
                                className={
                                    styles[
                                        'DownloadProductChooserModal__LegacyListItem'
                                    ]
                                }>
                                <button
                                    className={
                                        styles[
                                            'DownloadProductChooserModal__LegacyButton'
                                        ]
                                    }
                                    onClick={() => setIsExpanded(!isExpanded)}>
                                    Legacy products
                                    <span
                                        className={
                                            styles[
                                                'DownloadProductChooserModal__LegacyChevron'
                                            ]
                                        }>
                                        <Icon type="chevron" size="large" />
                                    </span>
                                </button>
                            </li>
                        )}
                        {isExpanded &&
                            _legacyProducts.map((dl, i) => (
                                <DownloadRow
                                    secondary={true}
                                    key={i}
                                    {...dl}
                                    onClick={handleDownload}
                                />
                            ))}
                    </ul>
                </div>
            )}

            {!loading && (
                <p className={styles['DownloadProductChooserModal__Help']}>
                    If your product is not listed, it is not compatible with the
                    selected sounds. Please use the search filter to find
                    compatible content for your product.
                </p>
            )}
        </div>
    );
};

DownloadProductChooserModal.propTypes = {};

export default DownloadProductChooserModal;
